import React from 'react';
import { fromJS } from 'immutable';
import { BaseComponent } from 'kryfe-lib';
import AutoCompleteComp from './ApplyFormCompChildDir/AutoCompleteComp';
import * as regExpDefault from 'shared/regExp';
import { Form, Icon, Input, Button, Row, Col, Radio, Modal } from 'antd';

import { UeAddParams } from 'shared/utils/commonUtil';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const regExp = regExpDefault.default;

class ApplyFormComp extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      // 提交按钮loading
      loading: false,
    };
  }

  // 提交表单
  handleSubmit = e => {
    _hmt.push(['_trackEvent', '按钮', '点击', '免费申请提交按钮']);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        let ueAddParams = UeAddParams();
        this.props.commitInfo(
          Object.assign(ueAddParams, values),
          header => {
            Modal.success({
              title: '恭喜您已免费申请成功',
              content: '请保持您的电话畅通，我们的客服人员将尽快与您联系！',
              okText: '确定',
              onOk: () => {
                _hmt.push(['_trackEvent', '按钮', '点击', '申请成功确认按钮']);
                this.props.form.setFieldsValue({
                  name: '',
                  gender: 1,
                  cellPhone: '',
                });
              },
            });
          },
          () => {
            this.setState({
              loading: false,
            });
          }
        );
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="applyFormComp">
        <Icon
          className="adress"
          type="environment-o"
          style={{
            color: 'rgba(0,0,0,.25)',
            position: 'absolute',
            left: '40px',
            bottom: '132px',
            zIndex: '1000',
          }}
        />
        <h1 className="title">在线申请</h1>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <Col className="gutter-row" span={12}>
            <FormItem>
              {getFieldDecorator('name', {
                initialValue: '',
                rules: [
                  { required: true, message: '请输入您的姓氏' },
                  { pattern: regExp.name, message: '请输入正确姓氏' },
                ],
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
                  }
                  size="large"
                  placeholder="请输入您的姓氏"
                  maxLength="16"
                  autoComplete="off"
                />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem>
              {getFieldDecorator('gender', {
                initialValue: 1,
              })(
                <RadioGroup size="large">
                  <Radio value={1}>先生</Radio>
                  <Radio value={2}>女士</Radio>
                </RadioGroup>
              )}
            </FormItem>
          </Col>

          <FormItem>
            {getFieldDecorator('cellPhone', {
              initialValue: '',
              rules: [
                { required: true, message: '请输入您的手机号' },
                { pattern: regExp.phone, message: '请输入正确手机号码' },
              ],
            })(
              <Input
                maxLength="11"
                prefix={
                  <Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />
                }
                size="large"
                placeholder="请输入您的手机号"
                autoComplete="off"
              />
            )}
          </FormItem>

          <FormItem>
            {getFieldDecorator('cityName', {
              initialValue: '',
              rules: [
                { required: true, message: '请输入您的所在城市' },
                {
                  pattern: /^[\u4e00-\u9fa5]+$/,
                  message: '请输入城市正确名称',
                },
              ],
            })(
              <AutoCompleteComp
                getCity={this.props.getCity}
                citySource={this.props.ApplyFormComp.get('citySource')}
              />
            )}
          </FormItem>

          <FormItem>
            <Button
              type="primary"
              htmlType="submit"
              loading={this.state.loading}
              style={{
                width: '100%',
                height: '50px',
                marginTop: '10px',
                color: '#fff',
                fontSize: '20px',
              }}
            >
              免费申请
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(ApplyFormComp);



// WEBPACK FOOTER //
// ./src/pages/newHome/components/ApplyForm/ApplyFormComp.jsx